<!--  -->
<template>
  <div class=''>
    <img src="../../assets/img/hot-banner.png" width="100%" alt="">
    <Modular  obj="Hot" name="modular1"></Modular>
    <Modular2  obj="Hot" name="modular2"></Modular2>
    <Modular  obj="Hot" name="modular3"></Modular>
  </div>
</template>

<script>
import Modular from '../../components/Modular'
import Modular2 from '../../components/Modular2'
export default {
  name:'Hot',
  components: {Modular,Modular2},
  props:{},
  data() {
     return {

     };
  },
  computed: {},
  watch: {},
  created() {
 
  },
  mounted() {

  },
  //方法集合
  methods: {

  },
}
</script>
<style lang='scss' scoped>
  //@import url(); 引入公共css类
  
</style>